const getProducts = () => {};

export default getProducts;
